<template>
  <el-input-number
    :model-value="props.modelValue"
    :min="props.min"
    :max="props.max"
    :disabled="props.disabled"
    :step="props.step"
    :step-strictly="!!props.step"
    @update:model-value="(value) => emit('update:modelValue', value)"
    @blur="onBlur"
  />
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: Infinity,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  step: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(['update:modelValue']);

// Methods
const onBlur = () => {
  if (props.modelValue === null) {
    emit('update:modelValue', props.min);
  }
};
</script>
